import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Navbar />
      <main className="flex flex-1 flex-col items-center justify-center px-4 py-20 text-center">
        <span className="font-heading text-7xl font-black text-foreground-200 md:text-[10rem]">404</span>
        <h1 className="mt-6 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          {t('common.notFoundTitle')}
        </h1>
        <p className="mt-2 font-mono text-sm text-foreground-500">{location.pathname}</p>
        <p className="mt-4 text-base text-foreground-600">{t('common.notFoundText')}</p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center justify-center rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
        >
          <i className="ri-arrow-left-line mr-1.5" />
          {t('article.backHome')}
        </Link>
      </main>
      <Footer />
    </div>
  );
}